import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useCreateWorkspace, useWorkspaces } from '../../api/queries';
import { Button, Card, Field, Input, PageHeader, Select } from '../../components/ui';
import { ErrorAlert } from '../billing/BillingNotices';
import { DEFAULT_TIME_ZONE, timeZones } from '../../lib/format';

export function CreateWorkspacePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const create = useCreateWorkspace();
  const workspaces = useWorkspaces();
  const [name, setName] = useState('');
  const [timeZone, setTimeZone] = useState(DEFAULT_TIME_ZONE);
  const first = workspaces.data?.items.length === 0;
  return (
    <div className="mx-auto max-w-xl">
      <PageHeader
        title={t(first ? 'workspace.welcomeTitle' : 'workspace.createTitle')}
        description={t('workspace.createBody')}
      />
      <Card>
        <form
          className="space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            if (!name.trim()) return;
            create.mutate(
              { name: name.trim(), timeZone },
              { onSuccess: (w) => void navigate(`/w/${w.id}/clients`) },
            );
          }}
        >
          {/* FR-BIL-16: a Free account owns one workspace (the alert links to the plans). */}
          {create.error ? <ErrorAlert error={create.error} /> : null}
          <Field label={t('workspace.name')} hint={t('workspace.nameHint')}>
            {(p) => (
              <Input
                required
                maxLength={100}
                value={name}
                onChange={(e) => setName(e.target.value)}
                {...p}
              />
            )}
          </Field>
          <Field label={t('workspace.timeZone')} hint={t('workspace.timeZoneHint')}>
            {(p) => (
              <Select value={timeZone} onChange={(e) => setTimeZone(e.target.value)} {...p}>
                {timeZones().map((z) => (
                  <option key={z} value={z}>
                    {z}
                  </option>
                ))}
              </Select>
            )}
          </Field>
          <Button type="submit" loading={create.isPending} disabled={!name.trim()}>
            {t('workspace.create')}
          </Button>
        </form>
      </Card>
    </div>
  );
}
